import { render, staticRenderFns } from "./PublicationsBySourceAndGsm.vue?vue&type=template&id=35522dc8&"
import script from "./PublicationsBySourceAndGsm.vue?vue&type=script&lang=js&"
export * from "./PublicationsBySourceAndGsm.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsBySourceAndGsm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports